export const Endpoints = {
    ClientServices: process.env.REACT_APP_CLIENT_SERVICE,
    SubmssionServices: process.env.REACT_APP_SUBMISSION_SERVICE,
    JobsLoggingServices: process.env.REACT_APP_JOBS_LOGGING_SERVICE,
    DataServices: process.env.REACT_APP_DATA_CONFIGURATION_SERVICE,
    CaseRecords: process.env.REACT_APP_CASE_RECORDS_SERVICE,
    FileManager: process.env.REACT_APP_FILE_MANAGER_SERVICE,
    ThirdParty: {
        Existing:
            "https://api-dev.efilemadeeasy.com/api/thirdparty/file/existingpackage",
        New: "https://api-dev.efilemadeeasy.com/api/thirdparty/file/newpackage",
    },
    Tyler: {
        PaymentExternalURL:
            "https://togatest.tylerhost.net/EPayments/Webs/EPayment.aspx",
        PaymentRedirect: "https://localhost:44384",
        PaymentKey: "CJOFS-CAStage-EFSP",
    },
    TylerFileService:
        "https://y41z0oqh6c.execute-api.us-east-1.amazonaws.com/Prod",
};
